import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Footer,
  Header,
  Sidebar,
} from "../../components";

import { Link } from "react-router-dom";

import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import BaseURL from "../../assets/utils/baseUrl";

const secureUrl = (url) => {
  if (!url) return "";

  return url.replace("http://", "https://");
};

const Agenda = () => {

  useDocumentTitle("Agenda - BAPENDA BEKASI");

  const [agenda, setAgenda] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageShow, setPageShow] = useState(0);

  const itemPerPage = 10;

  useEffect(() => {

    const getAgenda = async () => {

      try {

        setLoading(true);

       const response = await fetch(
  BaseURL + "index.php/api/Agenda",
  {
    method: "GET",

    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",

      // HARUS SAMA DENGAN BACKEND
      "X-Api-Key": "9f8d7a6c5b4e3f2a"
    }
  }
);

const result = await response.json();

console.log(result);

setAgenda(result.data || []);

        if (
          result.status === true &&
          Array.isArray(result.data)
        ) {

          setAgenda(result.data);

        } else {

          setAgenda([]);
        }

      } catch (error) {

        console.error(error);

        setAgenda([]);

      } finally {

        setLoading(false);
      }
    };

    getAgenda();

  }, []);

  // PAGINATION

  const indexOfLastItem =
    (pageShow + 1) * itemPerPage;

  const indexOfFirstItem =
    indexOfLastItem - itemPerPage;

  const currentItems = agenda.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPage = Math.ceil(
    agenda.length / itemPerPage
  );

  return (
    <div className="page">

      <Header active="publikasi" />

      <main className="main-sb">

        <section className="content">

          <Breadcrumb path="Publikasi / Agenda" />

          <div className="page-title-wrapper">

            <div className="page-title">
              Agenda
            </div>

          </div>

          {
            loading ? (

              <div
                style={{
                  padding: 20,
                  textAlign: "center"
                }}
              >
                Loading...
              </div>

            ) : (

              <div className="informasi-list-wrapper">

                {
                  currentItems.length > 0 ? (

                    currentItems.map((item) => (

                      <div
                        className="informasi-list-item"
                        key={item.id_agenda}
                      >

                        <div className="informasi-list-thumbnail-wrapper">

                         <img
  className="informasi-list-thumbnail"
  src={
    item.thumbnail
      ? secureUrl(
          BaseURL +
          "assets/images/agenda/" +
          item.thumbnail
        )
      : "/no-image.png"
  }
  alt={item.judul}
/>

                        </div>

                        <div className="informasi-list-informasi">

                          <div>

                            <p className="informasi-list-title">
                              {item.judul}
                            </p>

                            <p className="informasi-list-date">
                              {item.created_date}
                            </p>

                            <p className="informasi-list-desc">

                              {
                                item.konten
                                  ?.replace(/(_newline)/g, " ")
                                  ?.substring(0, 400)
                              }

                              {" "} [ ... ]

                            </p>

                          </div>

                          <Link
                            to={
                              "/agenda-detail/" +
                              item.id_agenda
                            }
                          >

                            <div className="informasi-list-desc link">
                              Selengkapnya
                            </div>

                          </Link>

                        </div>

                      </div>

                    ))

                  ) : (

                    <div
                      style={{
                        padding: 20,
                        textAlign: "center"
                      }}
                    >
                      Tidak ada data agenda
                    </div>

                  )
                }

              </div>

            )
          }

          {
            totalPage > 1 && (

              <div className="pagination-wrapper">

                {
                  Array.from(
                    { length: totalPage },
                    (_, i) => (

                      <div
                        key={i}

                        className={
                          i === pageShow
                            ? "page-number page-number-active"
                            : "page-number"
                        }

                        onClick={() => setPageShow(i)}
                      >
                        {i + 1}
                      </div>

                    )
                  )
                }

              </div>

            )
          }

        </section>

        <Sidebar />

      </main>

      <Footer />

    </div>
  );
};

export default Agenda;